"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RATIO_KEYS = exports.RATIO_NAMES = exports.RATIOS_BY_NAME = exports.RATIOS = void 0;
const RATIOS = {
  '16:9': {
    name: 'wide',
    width: 1280,
    height: 720,
    key: '16:9'
  },
  '1:1': {
    name: 'square',
    width: 720,
    height: 720,
    key: '1:1'
  },
  '9:16': {
    name: 'vertical',
    width: 720,
    height: 1280,
    key: '9:16'
  }
};
exports.RATIOS = RATIOS;
const RATIO_NAMES = Object.values(RATIOS).map(ratio => ratio.name);
exports.RATIO_NAMES = RATIO_NAMES;
const RATIO_KEYS = Object.keys(RATIOS);
exports.RATIO_KEYS = RATIO_KEYS;
const RATIOS_BY_NAME = {};
exports.RATIOS_BY_NAME = RATIOS_BY_NAME;
Object.entries(RATIOS).forEach(ratio => {
  RATIOS_BY_NAME[ratio[1].name] = ratio[1];
});